import React from 'react';

const HRManagement = () => {
  return (
    <div className="hr-management">
      <div className="page-header">
        <h2>İK Yönetimi</h2>
        <p>İnsan kaynakları yönetimini yapın</p>
      </div>
      <div className="placeholder-content">
        <h3>🚧 Geliştirme Aşamasında</h3>
        <p>Bu modül yakında eklenecektir.</p>
      </div>
    </div>
  );
};

export default HRManagement; 